// removed by extract-text-webpack-plugin
module.exports = {"maincolor":"#3cb8a2","bordercolor":"#7d7e80","errorcolor":"#ff4444","green":"#3cb8a2"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 53